var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 353,
    viewBox: "0 0 1280 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 353,
    fill: "#303376"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1102.73,
    cy: 132.726,
    r: 102.726,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.07 341.784C1027.03 359.806 1007.21 410.268 1007.21 410.268C1007.21 410.268 1004.14 365.903 1016.22 341.784C1030.99 312.294 1057.67 300.333 1081.1 287.717C1104.53 275.102 1147.59 271.547 1178.42 244.464C1205.27 220.881 1217.62 205.033 1227.08 170.573C1237.91 131.115 1219.87 66.0449 1219.87 66.0449C1219.87 66.0449 1279.34 120.111 1286.55 145.342C1293.76 170.573 1299.17 201.211 1293.76 231.849C1288.35 262.486 1269.19 283.34 1237.89 300.333C1174.81 334.575 1084.58 321.443 1054.07 341.784Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.26 94.8809C1250.26 94.8809 1251.81 96.2892 1254.43 98.7539C1269.47 114.866 1284.68 133.357 1288.11 145.342C1295.32 170.573 1300.72 201.211 1295.32 231.849C1289.91 262.486 1270.75 283.339 1239.45 300.332C1190.01 327.173 1123.87 324.906 1082.9 332.469C1092.31 326.501 1102.16 321.578 1111.49 316.553C1134.92 303.937 1177.98 300.383 1208.81 273.3C1235.66 249.717 1248.01 233.869 1257.47 199.409C1268.29 159.983 1250.29 94.986 1250.26 94.8809Z",
    fill: "#EFEFEF",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 353,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoFooter);
export default __webpack_public_path__ + "static/media/fondo_footer.9bff63194d1ae91126441faccaa05372.svg";
export { ForwardRef as ReactComponent };